@if (appUpdate.updateReady()) {
	<div class="app-update-banner" role="status" aria-live="polite">
		<div class="app-update-banner__content">
			<strong>{{ 'appUpdate.title' | translate }}</strong>
			<span>{{ 'appUpdate.message' | translate }}</span>
		</div>
		<div class="app-update-banner__actions">
			<ui-button
				type="button"
				color="primary"
				size="sm"
				[outline]="true"
				[label]="'appUpdate.later' | translate"
				(buttonClick)="dismissUpdateBanner()"
			/>
			<ui-button
				type="button"
				color="primary"
				size="sm"
				[label]="'appUpdate.reload' | translate"
				(buttonClick)="applyUpdate()"
			/>
		</div>
	</div>
}

<router-outlet />
<app-toast-host />
